import { Component } from '@angular/core';
import { Platform, App, MenuController, Events } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Storage } from '@ionic/storage';
//import { HomePage } from '../pages/home/home';
//import { JobsPage } from '../pages/jobs/jobs';
//import { OrdersPage } from '../pages/orders/orders';

//import { LoginPage } from '../pages/login/login';
//import { SettingsPage } from '../pages/settings/settings';
//import { CreateBlueprintPage } from '../pages/create-blueprint/create-blueprint';
//import { CreateOrderPage } from '../pages/create-order/create-order';

import {SplitPaneProvider} from '../providers/split-pane/split-pane';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Globalization } from '@ionic-native/globalization';
import { GlobalProvider } from "../providers/global/global";

//import { WelcomePage } from '../pages/welcome/welcome';

///<reference path="jscolor.d.ts"/>

// import { Events } from 'ionic-angular';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {

  // public events: Events
  //rootPage:any = JobsPage;
  //rootPage:any = WelcomePage;
  rootPage:string = 'HomePage';
  loggedIn: any;

  splitPaneState : boolean = true;

  category: any;

  token: any;
  

  constructor(private globalization: Globalization, public translate: TranslateService, platform: Platform, 
          statusBar: StatusBar, splashScreen: SplashScreen,public splitPane : SplitPaneProvider, 
          public app : App, public menu : MenuController, private storage: Storage, private events: Events, public global: GlobalProvider) {
        platform.ready().then(() => {
          // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault();
      splashScreen.hide();

      //Toggle Menu Event
      events.subscribe('menu:toggle', (toggle) => {
        if (toggle) {
          menu.enable(false);
        }else{
          menu.enable(true);
        }
        
      });

        //Define Constants
          let availableLanguages = [{
                code: 'en',
                name: 'English'
              }, {
                code: 'de',
                name: 'German'
              }];
          let defaultLanguage = 'en';
          let sysOptions = {
            systemLanguage: defaultLanguage
          };



        // this language will be used as a fallback when a translation isn't found in the current language
        translate.setDefaultLang(defaultLanguage);

        if ((<any>window).cordova) {
          globalization.getPreferredLanguage().then(result => {
            var language = this.getSuitableLanguage(defaultLanguage,availableLanguages,result.value);
            console.log('Use Cordova language: ', language);
            translate.use(language);
            sysOptions.systemLanguage = language;
          });
        } else {
          let browserLanguage = translate.getBrowserLang() || defaultLanguage;
          var language = this.getSuitableLanguage(defaultLanguage,availableLanguages,browserLanguage);
          console.log('Use language: ', language);
          translate.use(language);
          sysOptions.systemLanguage = language;
        }

      }
    );
     //translate.setDefaultLang('en');
    translate.onLangChange.subscribe((event: LangChangeEvent) => {
      console.log("lang changed detected", event);
      translate.setDefaultLang(event.lang);
    });

    // this.storage.get('AppLangcode')
    //       .then((AppLangcode) => {
    //         if(AppLangcode==null){
    //           translate.setDefaultLang('en');
    //         }else{
    //           translate.setDefaultLang(AppLangcode);
    //         }
    //       });


     // this.token = localStorage.getItem('token');
     //this.splitPaneState = true;
     // if(!this.token){
     //  console.log('No token!');
     //  this.rootPage = 'LoginPage';
     // } else {
     //   console.log('have token!');
     // }
     
     // this.storage.get('has_stream').then((stream) => {

     //      this.has_stream = stream;
     //  });

     this.storage.get('has_crm').then((crm) => {
        console.log("HAS CRM !!!!", crm);
          this.global.has_crm = crm;
      });
     this.storage.get('has_stream').then((stream) => {
        console.log("HAS Stream !!!!", stream);
          this.global.has_stream = stream;
      });
     this.storage.get('is_partner').then((partner) => {
        console.log("IS Partner !!!!", partner);
          this.global.is_partner = partner;
      });
     this.storage.get('is_worker').then((worker) => {
        console.log("IS Worker !!!!", worker);
          this.global.is_worker = worker;
      });

     // Working
     this.storage.get('token').then((isLoggedIn) => {
        
        this.loggedIn = isLoggedIn;
        if(!this.loggedIn){
            //this.splitPaneState = false;
            //this.menu.enable(false);
            console.log('not logged in!');
            this.rootPage = 'LoginPage';
        }
        else if(this.loggedIn) {
          //this.splitPaneState = true;
            //this.menu.enable(true);
            //this.rootPage = 'HomePage';
            console.log('Is Logged in : ', isLoggedIn);
        }
    });

  }



 getSuitableLanguage(defaultLanguage, availableLanguages,language) {
    language = language.substring(0, 2).toLowerCase();
    return availableLanguages.some(x => x.code == language) ? language : defaultLanguage;
  }

  setCategory(category) {
    switch (category) {
      case 'list':
        this.rootPage = 'HomePage';
        break;
      case 'list-orders':
        this.rootPage = 'OrdersPage';
        break;
      case 'crm':
        this.rootPage = 'CrmPage';
        break;
      case 'dashboard':
        this.rootPage = 'DashboardPage';
        break;
      case 'stream':
        this.rootPage = 'StreamPage';
        break;
      case 'partners':
        this.rootPage = 'PartnersPage';
        break;
    }
  }

 backToWelcome() {
    this.rootPage = 'HomePage';
    // const root = this.app.getRootNav();   
    // root.popToRoot();
  }

  logout() {
    //Api Token Logout
    this.storage.clear();
    localStorage.clear();
    this.menu.enable(false);
    setTimeout(() => {this.rootPage = 'LoginPage';}, 1000);
  }

  // listenToEvents() {
  //   this.events.subscribe('user:logout', () => {
  //     this.nav.setRoot(LoginPage);
  //   });
  // }

}




// WEBPACK FOOTER //
// ./src/app/app.component.ts